export const set = (key, value) => window.localStorage.setItem(key, value);
export const get = key => window.localStorage.getItem(key);
export const remove = key => window.localStorage.removeItem(key);
export const clear = () => window.localStorage.clear();



// WEBPACK FOOTER //
// ./src/utils/storage.js